<template>

	<div class="order_list" @scroll="getData">

		<Header title="我的订单" :haveHeight="true" url="transparent" :customEventRout="customEventRout"></Header>

		<div class="title">
			<div class="title_wrap">
				<div class="title_left" :class="{'active_title':type==1}" @click="active(1)">我的购买</div>
				<div class="title_right" :class="{'active_title':type==2}" @click="active(2)">我的求购</div>
				<div class="title_bor" :class="{'active_bor':type==2}"></div>
			</div>
		</div>
		
		<div class="notDate_list" v-if="err" >
			<img src="../../assets/images/order/not_order.png" alt="">
			<div class="notDate_err" >{{err}}</div>
		</div>
		
		<!-- 我的购买列表 -->
		<Shop v-if="type==1" ref="shop" @gotoDetail="gotoDetail" @notDate="notDate" ></Shop>
		<!-- 我的求购列表 -->
		<Buy v-if="type==2" ref="buy" @gotoDetail="gotoDetail" @notDate="notDate" ></Buy>
		
		
		
	</div>

</template>

<script>
    import { toapp } from "@/utils/utils";
	import Shop from '@/components/order/list/shop'//我的购买列表
	
	import Buy from '@/components/order/list/buy'//我的求购
	
	export default {
		components:{
			Shop,
			Buy
		},
		data() {
			return {
				type: 1,//1 我的购买 2我的求购
				status: true,
				err:"",
			}
		},
		mounted() {
			this.type = this.$route.query.type||1
			if(this.$route.query.token){
				localStorage.setItem('token',this.$route.query.token)
			}
			this.init()
		},
		methods: {
			init() { //初始化数据
				this.type == 2 ? this.$refs.buy.apply_list() : this.$refs.shop.newBuyList()
			},
			active(type) { //选择类型
				if (type == this.type) return
				this.type = type
				this.page =1
				this.list=[]
				this.err=''
				setTimeout(()=>{
					this.init()
				},10)
			},
			
			gotoDetail(item) { //去详情
				this.$router.push({
					name: "orderDetail",
					query: {
						id: item.id,
						type: this.type
					}
				})
			},
			getData(e) { //滚动条事件 
			    //安卓手机滚动条出现小数点 所以去除小数点
				if (Number(e.srcElement.scrollTop.toFixed(0)) + Number(e.srcElement.clientHeight) == e.srcElement.scrollHeight) {
					if(this.status){
						this.init()
					}
				}
			},
			notDate(item){//没有数据
				this.err=item
			},

            // 自定义头部后退方法
            customEventRout () {
                toapp(1);
            },
		}

	}
</script>

<style lang="less">
@import './list.less';
</style>
